// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3VAuM","title":"InfoRow_title__3FpsL"};